module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Sally4Ever-S1.da65249.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Sally4Ever-S1.jpg
// module id = JHsJ
// module chunks = 0